import { MedicalEducation } from "./MedicalEducation";
import Resident from "./Resident";

export default class ResidentInformation {
    constructor(resident: Resident, medicalEducation: MedicalEducation) {
        this.medicalEducation = medicalEducation;
        this.resident = resident;
    }
    
    resident: Resident;
    medicalEducation: MedicalEducation;
}